
import { PeriodPartSelectionEnum } from "../enums/periodPartSelectionEnum";
import { TimeIntervalEnum } from "../enums/timeIntervalEnum";

import * as appsettings from "../appsettings";
import * as main from "../main";
import * as moment from "moment";
import * as timeinterval from "../timeinterval";

let dateTimeErrorMessageLabel = "";

/*
* Show / Hide Period Selector
**/
function setVisibilityPeriodSelector(): void {
    var timeinterval_value = parseInt($("#TimeInterval").data("kendoDropDownList").value());

    if (timeinterval_value == TimeIntervalEnum.AskedPeriod) {
        $("#periodSelector").show();
    } else {
        $("#periodSelector").hide();
    }
}

function showErrorMessage(errorMessageLabel: string): void {
    // Hide Indicator
    $("#RegioReportExportRawButtonLoader").hide();
    $("#RegioReportExportButtonLoader").hide();
    $("#RegioReportSearchButtonLoader").hide();

    // make a message
    main.setHideDiv("errorMessage", true);

    const lblError = $("#errorMessageLabel");
    if (lblError != null && lblError != undefined) {
        if (errorMessageLabel) {
            lblError.text(errorMessageLabel);
        } else {
            lblError.text(dateTimeErrorMessageLabel);
        }
    }
}

/**
* Initialize
*/
export function initialize(dateTimeErrorMessage: string): void {
    dateTimeErrorMessageLabel = dateTimeErrorMessage;

    main.setHideDiv("errorMessage", false);
    $("#RegioReportExportRawButtonLoader").hide();
    $("#RegioReportExportButtonLoader").hide();
    $("#RegioReportSearchButtonLoader").hide();

    setVisibilityPeriodSelector();
}

/**
* Initialize Search
*/
export function initializeSearch(): void {
    $(".groupItem").hide();
}

/**
* Click groupItem 
*/
export function groupItemClick(guid: string): void {

    let selection: any;

    if ($('#' + guid).is(':hidden')) {
        $('#' + guid).slideDown("slow");
        selection = $("#" + guid).parent().find('.k-i-caret-double-alt-down');

        $(selection).removeClass("k-i-caret-double-alt-down");
        $(selection).addClass("k-i-caret-double-alt-up");
    }
    else {
        $('#' + guid).slideUp("slow");
        selection = $("#" + guid).parent().find('.k-i-caret-double-alt-up');

        $(selection).removeClass("k-i-caret-double-alt-up");
        $(selection).addClass("k-i-caret-double-alt-down");
    }
}

/**
* Action export (will download excel document according to the selected period)
*/
export function exportAction(e: kendo.ui.ButtonClickEvent): void {
    // Stop the browser from following
    e.preventDefault();

    main.setHideDiv("errorMessage", false);

    // Show the waiting indicator
    $("#RegioReportExportButtonLoader").show();

    // get preference / options selected
    const selectedInterval = Number($("#TimeInterval").data("kendoDropDownList").value());

    // Get selection period
    let from = "";
    const fromDt = timeinterval.getBeginPeriodSelection(selectedInterval, "From");
    if (fromDt) {
        from = fromDt.toUTCString();
    }

    let to = "";
    const toDt = timeinterval.getEndPeriodSelection(selectedInterval, "To");
    if (toDt) {
        to = toDt.toUTCString();
    }

    if (from != "" && to != "") {
        // Download File
        $.fileDownload(appsettings.getLocalUrl("RegioReport/Export?from=" + from + "&to=" + to))
            .done(function () { $("#RegioReportExportButtonLoader").hide(); })
            .fail(function () { $("#RegioReportExportButtonLoader").hide(); });
    }
    else {
        showErrorMessage("Error");
    }
}

/**
* Action export (will download excel document according to the selected period)
*/
export function exportRawAction(e: kendo.ui.ButtonClickEvent): void {
    // Stop the browser from following
    e.preventDefault();

    main.setHideDiv("errorMessage", false);

    // Show the waiting indicator
    $("#RegioReportExportRawButtonLoader").show();

    // get preference / options selected
    const selectedInterval = Number($("#TimeInterval").data("kendoDropDownList").value());

    // Get selection period
    const fromDt = timeinterval.getBeginPeriodSelection(selectedInterval, "From");
    let from = "";
    if (fromDt) {
        from = fromDt.toUTCString();
    }

    const toDt = timeinterval.getEndPeriodSelection(selectedInterval, "To");
    let to = "";
    if (toDt) {
        to = toDt.toUTCString();
    }

    if (from != "" && to != "") {
        // Download File
        $.fileDownload(appsettings.getLocalUrl("RegioReport/ExportRaw?from=" + from + "&to=" + to), {
            failCallback: function (responseHtml: string, url: string) {
                const plainText = $("<div>").html(responseHtml).text();
                showErrorMessage(plainText);
            }
        })
            .done(function () { $("#RegioReportExportRawButtonLoader").hide(); });
    }
    else {
        showErrorMessage("Error");
    }
}


/**
* Action search (will display certain bar charts according to the selected period)
*/
export function searchAction(): void {
    // Indicator
    $("#RegioReportSearchButtonLoader").show();

    main.setHideDiv("errorMessage", false);

    // get preference / options selected
    let selectedInterval = Number($("#TimeInterval").data("kendoDropDownList").value());
    let selectedPeriod = Number($("#PeriodPartSelection").data("kendoDropDownList").value());

    // Get selection period
    let From = "";
    let FromDt = timeinterval.getBeginPeriodSelection(selectedInterval, "From");
    if (FromDt != null) {
        From = moment(FromDt.toUTCString()).format("YYYY-MM-DD[T]HH:mm:ss");
    }

    let To = "";
    let ToDt = timeinterval.getEndPeriodSelection(selectedInterval, "To");
    if (ToDt != null) {
        To = moment(ToDt.toUTCString()).format("YYYY-MM-DD[T]HH:mm:ss");
    }

    if (From != "" && To != "") {
        // Do request
        $.ajax({
            type: "GET",
            url: appsettings.getUrl("RegioReport/Search"),
            data: {
                From: From,
                To: To,
                WorkingDay: selectedPeriod == PeriodPartSelectionEnum.FullPeriod ? null : selectedPeriod
            },
            success: function (responseData) {
                // Get response
                $("#searchResult").html(responseData);

                // Hide Indicator
                $("#RegioReportSearchButtonLoader").hide();
            }
        });
    }
    else {
        showErrorMessage("Error");
    }
}

/**
* start / from 
*/
export function fromChange(): void {
    const start = $("#From").data("kendoDateTimePicker");
    const end = $("#To").data("kendoDateTimePicker");
    let startDate = start.value();
    let endDate = end.value();

    if (startDate) {
        startDate = new Date(startDate);
        startDate.setDate(startDate.getDate());
        end.min(startDate);
    } else if (endDate) {
        start.max(new Date(endDate));
    } else {
        endDate = new Date();
        start.max(endDate);
        end.min(endDate);
    }
}

/**
* end / to
*/
export function toChange(): void {
    const start = $("#From").data("kendoDateTimePicker");
    const end = $("#To").data("kendoDateTimePicker");
    let endDate = end.value();
    let startDate = start.value();

    if (endDate) {
        endDate = new Date(endDate);
        endDate.setDate(endDate.getDate());
        start.max(endDate);
    } else if (startDate) {
        end.min(new Date(startDate));
    } else {
        endDate = new Date();
        start.max(endDate);
        end.min(endDate);
    }
}

export function onChangeTimeInterval(): void {
    setVisibilityPeriodSelector();
}
